import React from "react";
import { SVG } from "./SVGImage.styles";

type IconType =
  | "CIMConfigurationSVG"
  | "PumpCloudSyncSvg"
  | "CIMConfigurationSVG"
  | "SetupPumpsSvg"
  | "ImeiQRSvg"
  | "MacBarSvg"
  | "SetupPumpsAndSensorsSvg"
  | "CIMUpdateFirmwareSVG"
  | "CloudGatewaySVG"
  | "SensorOutlinedSvg"
  | "SetupSensorsSvg"
  | "Replace_Gateway_Graphics"
  | "Rediscover_installation"
  | "software_outline"
  | "controller_outline";

interface Props {
  icon: IconType;
  style?: React.CSSProperties;
}

const SVGImage = ({ icon, style }: Props) => {
  return (
    <SVG
      src={`https://cdn.grundfos.com/core-widgets/v1/svg/${icon}.svg`}
      style={style}
    />
  );
};

export default SVGImage;
